import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

import "./ScreenLoader.scss";

export default function ScreenLoader({ className = "", ...props }) {
	return (
		<div className={`ScreenLoader ${className}`}>
			<CircularProgress />
		</div>
	);
}

ScreenLoader.propTypes = {
	className: PropTypes.string,
};
